export default __webpack_public_path__ + "static/media/108.78b04317.gif";